import PhotoGalleryContainer from "../../container/admin/photo-gallery-master";

const PhotoGallery = () => {
    return <PhotoGalleryContainer />;
};

export default PhotoGallery;